import { render, staticRenderFns } from "./PerEmp.vue?vue&type=template&id=8d74232c"
import script from "./PerEmp.vue?vue&type=script&lang=js"
export * from "./PerEmp.vue?vue&type=script&lang=js"
import style0 from "./PerEmp.vue?vue&type=style&index=0&id=8d74232c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports